'use client';

import React, { useEffect } from 'react';
import { setTrackingCookiesFromUrlParams } from '@/components/utils/surveyDataUtils';

const LandingPageCookieHandler: React.FC = () => {
  useEffect(() => {
    setTrackingCookiesFromUrlParams();
  }, []);

  return null;
};

export default LandingPageCookieHandler;
